









import Vue from "vue";
import NavBar from "./components/NavBar.vue";
import { ROUTES } from "@/constants/routes";
export default Vue.extend({
  data(): { requestEmailPath: string; landingPath: string } {
    return {
      requestEmailPath: ROUTES.REQUEST_EMAILS.path,
      landingPath: ROUTES.LANDING.path,
    };
  },
  components: {
    NavBar,
  },
});
console.log(process.env.VUE_APP_ENDPOINT_LOGIN);
